/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {getCSS, getCSSVariableValue} from '../../../assets/ts/_utils'
import {useThemeMode} from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
  className: string
  label?: any
  value?: any
}

const ChartsWidget13: React.FC<Props> = ({className, label, value}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const {mode} = useThemeMode()

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }
    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, value, label))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart()
    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, value, label])

  return (
    <div className={`card ${className}`}>
      <h5 className='card-title align-items-start flex-column pt-5 px-8 pb-0'>
        <span className='card-label fw-bolder mb-1'>Licenças Renovadas</span>
      </h5>
      {/* begin::Chart */}
      <div
        ref={chartRef}
        id='kt_charts_widget_2_chart'
        style={{
          height: '295px',
        }}
      ></div>
      {/* end::Chart */}
      {/* end::Body */}
    </div>
  )
}

export {ChartsWidget13}

function getChartOptions(height: number, value: any, label: any): ApexOptions {
  const labelColor = getCSSVariableValue('--kt-gray-500')
  const borderColor = getCSSVariableValue('--kt-gray-200')
  // const baseColor = getCSSVariableValue('--kt-warning')
  // const secondaryColor = getCSSVariableValue('--kt-gray-300')

  return {
    series: [
      {
        name: 'Licenças',
        data: [
          {
            x: 'L. Ativas',
            y: value[0],
            fillColor: '#009EF7',
          },
          {
            x: 'L. Válidas',
            y: value[1],
            fillColor: '#1BC4C5',
          },
          {
            x: 'L. Venc.',
            y: value[2],
            fillColor: '#FE383A',
          },
          {
            x: 'L. Renov.',
            y: value[3],
            fillColor: '#F6C000',
          },
          {
            x: 'L. Subst.',
            y: value[4],
            fillColor: '#8950FC',
          },
          {
            x: 'L. Não Renov.',
            y: value[5],
            fillColor: '#FF900D',
          },
        ],
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '30%',
        borderRadius: 5,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: [label[0], label[1], label[2], label[3], label[4], label[5]],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return `${val}`
        },
      },
    },

    colors: ['#fdadf6', '#ff2a'],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  }
}
